// extracted by mini-css-extract-plugin
module.exports = {"canvas":"idt-photoprintpreview_canvas__1m5pp"};